import { render, staticRenderFns } from "./addJZForm.vue?vue&type=template&id=c9265b64&scoped=true&"
import script from "./addJZForm.vue?vue&type=script&lang=js&"
export * from "./addJZForm.vue?vue&type=script&lang=js&"
import style0 from "./addJZForm.vue?vue&type=style&index=0&id=c9265b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9265b64",
  null
  
)

export default component.exports